import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

const BlogPostPreview = ({ path, fixedImage, title, excerpt, date }) => (
  <div className="media">
    <Link to={path} className="plain-link">
    { fixedImage ? (
   	  <Img className="align-self-start mr-3" style={{ width: '150px', height: '150px' }}
        fixed={fixedImage} />
    ) : null }
    </Link>
    <div className="media-body">
      <Link to={path} className="plain-link">
        <h3 className="mt-0 mb-2">
          {title}
        </h3>
      </Link>
      <Link to={path} className="plain-link">
        <h5 className="mt-2 mb-2">
          {excerpt}
        </h5>
      </Link>
      <h5 className="mt-2">
        <time>{date}</time>
      </h5>
    </div>
	</div>
)

export default BlogPostPreview

/*
        &nbsp;&middot;&nbsp;
        {post.timeToRead} min read

<Link to={path}>
</Link>
*/